module.exports = __webpack_public_path__ + "fonts/Barlow-SemiBold.8247eae.ttf";